import { render } from "./GasRegister.vue?vue&type=template&id=703aad2c&scoped=true&ts=true"
import script from "./GasRegister.vue?vue&type=script&lang=ts"
export * from "./GasRegister.vue?vue&type=script&lang=ts"

import "./GasRegister.vue?vue&type=style&index=0&id=703aad2c&scoped=true&lang=css"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-703aad2c"]])

export default __exports__